import React, {FC, useState} from 'react';
import {CloseIcon, FormCustomInput} from 'components';
import {useQuery} from 'hooks';
import {DirectBookingFormData} from 'interfaces';
import {Control, Controller, UseFormSetValue} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router';

import {SearchIcon} from './Icons';

type IProps = {
  classes?: string;
  control: Control<DirectBookingFormData>;
  setValue: UseFormSetValue<DirectBookingFormData>;
};

const SearchBox: FC<IProps> = ({control, classes, setValue}) => {
  const query = useQuery();
  const history = useHistory();
  const {t} = useTranslation();
  const [searchText, setSearchText] = useState('');

  const onSearch = (queryText: string) => {
    if (queryText?.trim()?.length) {
      query.set('searchText', queryText);
    } else {
      query.delete('searchText');
    }
    history.replace({search: query.toString()});
  };

  const clearSearch = () => {
    query.delete('searchText');
    history.replace({search: query.toString()});
    setValue('searchText', '');
    setSearchText('');
  };

  return (
    <section className={`flex items-center w-full h-full lg:px-3 ${classes}`}>
      <label htmlFor="search_friends" className="w-full  relative">
        <Controller
          name="searchText"
          control={control}
          render={({field: {onChange, value}}) => (
            <FormCustomInput
              id="searchText"
              name=""
              className="font-inter text-base font-normal text-black placeholder:text-darkGray border py-4 pl-4 !pr-16 bg-white rounded-2xl focus:shadow-none focus:border-blue-600"
              bgColor="bg-white"
              placeholder={t('directory.searchProviders', 'Search providers')}
              onChange={e => {
                const changedValue = e.target.value;
                setSearchText(changedValue);
                onSearch(changedValue);
                onChange(changedValue);
              }}
              value={value ?? searchText}
            />
          )}
        />
        <div className="w-5 h-5 absolute top-4 right-10 flex justify-center items-center">
          {searchText ? (
            <button className="" onClick={clearSearch}>
              <CloseIcon strokeColor="text-gray-700" strokeWidth={20} />
            </button>
          ) : null}
        </div>
        <div className="w-5 h-5 absolute top-[18px] right-4">
          <SearchIcon />
        </div>
      </label>
    </section>
  );
};

export default SearchBox;
